import { FieldType } from 'src/Common/Filters/interfaces/FiltersView';

export const rbFilterConfig = [
  {
    fieldId: 'ActionOwner',
    fieldName: 'Action Owner',
    fieldType: FieldType.PickerComponent,
    internalName: 'fields/assignedto/uniquename',
    responseFormat: 'string',
  },
  {
    fieldId: 'Area',
    fieldName: 'Area',
    fieldType: FieldType.CustomDropdown,
    fieldDropdownName: 'areas',
    keyName: 'area',
    internalName: 'fields/areafield',
    responseFormat: 'string',
  },
  {
    fieldId: 'EOU',
    fieldName: 'EOU',
    fieldType: FieldType.CustomDropdown,
    fieldDropdownName: 'eous',
    keyName: 'eou',
    internalName: 'fields/eou',
    responseFormat: 'string',
    isCustomField: true,
  },
  {
    fieldId: 'Requestor',
    fieldName: 'Requestor',
    fieldType: FieldType.PickerComponent,
    internalName: 'fields/requestorsinfo/uniquename',
    responseFormat: 'arrayOfObjects',
  },
  {
    fieldId: 'State',
    fieldName: 'State',
    fieldType: FieldType.Dropdown,
    fieldDropdownName: 'workItemStates',
    keyName: 'Name',
    internalName: 'fields/state',
    responseFormat: 'string',
  },
  {
    fieldId: 'TechnicalFeedback',
    fieldName: 'Technical Feedback',
    fieldType: FieldType.Dropdown,
    fieldDropdownName: 'yesOrNo',
    keyName: 'yesOrNo',
    internalName: 'fields/onelistfeedback',
    responseFormat: 'string',
    isCustomField: true,
  },
];
